import axios from "axios";
import { endpoints } from "./endpoints";
import {
  CREDENTIAL_ISSUE,
  SERVER_GENERAL_SERVER_ERRROR,
  ERR_NETWORK,
} from "../helpers/const";
import { makeQueryParams } from "../helpers/helperFunctions";
export const apiGet = {
  test: getTestPayload,
  authToken: getAuthenticationToken,
  checkLogin: getCheckLogin,
  logOut,
  getGroups,
  getInitialProducts,
  getProductById,
  getAlternativeProduct,
  getOrderHistory,
  getCustomerWarehouseCutoff,
  getOrderById,
  getProductListRowDetails,
  getCustomerLoginAs,
  getCart,
  getInvoice,
  getProductFilterTypes,
  getProductHistory,
  getAdminVars,
  getCustomerDetailsForOrder,
  getOrderItemRepresentation,
  getTrackMakesAndModels,
  getTrackFee,
  getOrdersList,
  getCreditsByFilter,
  getInvoicesByFilter,
  getQuotesList,
  getCredit,
  getQuoteById,
  sendCreditConfirmation,
  getApiRequestLogs,
  getApiRequestLogDetail,
  getActiveVendorCategories,
  getUserById,
  getTemplateUsers,
  getVersionByName,
  checkNewVersionAvailable,
  getZipLookup,
  checkDuplicatePo,
  getAsyncJob,
};

// *************  API functions  *************

function getTestPayload() {
  console.log("getTestPayload");
  return axios
    .get(`${endpoints.TESTAPI_URL}/2`)
    .then((res) => {
      return res.data.title;
    })
    .catch((err) => {
      return err;
    });
}

async function getAuthenticationToken() {
  try {
    const loginURL = endpoints.MITCO_API_URL + endpoints.USER_LOGIN;
    const response = await axios.get(loginURL, {
      withCredentials: true,
      headers: {
        Accept: "application/json",
      },
    });
    return response?.data?.csrfmiddlewaretoken?.initial_value;
  } catch (error) {
    let message = error.code === "ERR_NETWORK" ? ERR_NETWORK : error.message;
    throw new Error(message);
  }
}

async function logOut() {
  try {
    await axios.get(endpoints.MITCO_API_URL + endpoints.USER_LOGOUT, {
      withCredentials: true,
      headers: {
        Accept: "application/json",
      },
    });
  } catch (error) {
    throw new Error(error.message);
  }
}

async function getCheckLogin() {
  const response = await axios.get(
    endpoints.MITCO_API_URL + "/users/check_login/",
    {
      withCredentials: true,
      headers: {
        Accept: "application/json",
      },
    },
  );

  return response;
}

async function getGroups() {
  try {
    const response = await axios.get(
      endpoints.MITCO_API_URL + "/v1/csa/groups/get_groups/",
      {
        withCredentials: true,
        headers: {
          Accept: "application/json",
        },
      },
    );
    return response.data;
  } catch (error) {
    let message = "";
    if (error?.request?.status === 403) {
      message = CREDENTIAL_ISSUE;
    } else {
      message = SERVER_GENERAL_SERVER_ERRROR;
    }
    if (error.code === "ERR_NETWORK") {
      message = ERR_NETWORK;
    }
    throw new Error(message);
  }
}

//Item Endpoints

async function getInitialProducts() {
  const response = await axios.get(
    endpoints.MITCO_API_URL +
      endpoints.CSFA_BASE +
      endpoints.CSFA_PRODUCTS +
      endpoints.CSFA_INITIAL_PRODUCTS,
    {
      withCredentials: true,
      headers: {
        Accept: "application/json",
      },
    },
  );
  return response;
}

async function getInvoicesByFilter({
  invoice_num,
  customer_num,
  ref_number,
  customer_po,
  search,
  to,
  from,
  page,
  order_by,
  sort_order,
}) {
  const url = `${endpoints.MITCO_API_URL}${endpoints.CSFA_BASE}${endpoints.INVOICE_BASE}`;

  const response = await axios.get(url, {
    withCredentials: true,
    headers: {
      Accept: "application/json",
    },
    responseType: "application/json",
    params: {
      invoice_num,
      customer_num,
      ref_number,
      customer_po,
      search,
      to,
      from,
      page,
      order_by,
      sort_order,
      source: "csfa",
    },
  });

  return response;
}

async function getInvoice(
  transactionNum,
  transactionNumType,
  deliveryMethod,
  countQuery,
  useOverride,
  showPricing,
) {
  const params = {
    type: transactionNumType,
    transaction_num: transactionNum,
    return_method: deliveryMethod === "pdf" ? "pdf" : "file",
    use_override: useOverride,
    source: "csfa",
  };

  const url = `${endpoints.MITCO_API_URL}/v1${endpoints.INVOICES}`;

  const response =
    (deliveryMethod === "file" || deliveryMethod === "pdf") && !countQuery
      ? await axios.get(url, {
          withCredentials: true,
          headers: {
            Accept: "application/json",
          },
          responseType: "blob",
          params: params,
        })
      : await axios.get(url, {
          withCredentials: true,
          headers: {
            Accept: "application/json",
          },
          params: params,
        });

  return response;
}

async function getQuotesList({
  quoteId,
  page,
  customerNum,
  customerName,
  company,
  orderBy,
  sortOrder,
  from,
  to,
}) {
  let parameters = `${company ? `?company=${company}` : "?company=mitco"}`;
  parameters += `${quoteId ? `&quote_num=${quoteId}` : ""}`;
  parameters += `${customerNum ? `&customer_num=${customerNum}` : ""}`;
  parameters += `${customerName ? `&customer_name=${customerName}` : ""}`;
  parameters += `${company ? `&company=${company}` : ""}`;
  parameters += `${page ? `&page=${page}` : ""}`;
  parameters += `${orderBy ? `&order_by=${orderBy}` : ""}`;
  parameters += `${sortOrder ? `&sort_order=${sortOrder}` : ""}`;
  parameters += `${from ? `&from=${from}` : ""}`;
  parameters += `${to ? `&to=${to}` : ""}`;
  parameters += `&source=csfa`;

  const response = await axios({
    method: "get",
    withCredentials: true,
    url:
      endpoints.MITCO_API_URL + "/v1" + endpoints.CSFA_QUOTE_BASE + parameters,
    headers: {
      Accept: "application/json",
    },
  });
  return response.data;
}

async function getOrdersList({
  company = "mitco",
  customerOrderNum,
  customerNum,
  customerName,
  customer_po,
  customer_invoice_num,
  dropShipAddress,
  productCode,
  description,

  from,
  to,
  orderStatus,
  orderBy,
  sortOrder,
  strictMatch = false,
  page,
}) {
  const parameters = makeQueryParams({
    company,
    suborder_num: customerOrderNum,
    customer_num: customerNum,
    customer_name: customerName,
    drop_ship: dropShipAddress,
    product_code: productCode,
    customer_po,
    customer_invoice_num,
    description,
    from,
    to,
    status: orderStatus,
    order_by: orderBy,
    sort_order: sortOrder,
    strict_match: strictMatch,
    page,
    source: "csfa",
  });

  const response = await axios({
    method: "get",
    withCredentials: true,
    url: `${endpoints.MITCO_API_URL}${endpoints.CSFA_BASE}${endpoints.CSFA_ORDERS}${endpoints.CSFA_ORDER_LIST}${parameters}`,
    headers: {
      Accept: "application/json",
    },
  });

  return response.data;
}

async function getCredit(credit_memo_num) {
  const url = `${endpoints.MITCO_API_URL}/v1${endpoints.CSFA_CREDIT_BASE + credit_memo_num + "/"}`;

  const response = await axios.get(url, {
    withCredentials: true,
    headers: {
      Accept: "application/json",
    },
    responseType: "json",
    params: {
      credit_memo_num,
      source: "csfa",
    },
  });
  return response;
}

async function getQuoteById(quote_num) {
  const url = `${endpoints.MITCO_API_URL}/v1${endpoints.CSFA_QUOTE_BASE + quote_num + "/"}`;

  const response = await axios.get(url, {
    withCredentials: true,
    headers: {
      Accept: "application/json",
    },
    responseType: "json",
    params: {
      quote_num,
      source: "csfa",
    },
  });
  return response;
}

async function getCreditsByFilter({
  credit_memo_num,
  ref_invoice,
  return_address,
  to,
  from,
  status,
  customer_num,
  selected,
  page,
  order_by,
  sort_order,
}) {
  const url = `${endpoints.MITCO_API_URL}/v1${endpoints.CSFA_CREDIT_BASE}`;

  const response = await axios.get(url, {
    withCredentials: true,
    headers: {
      Accept: "application/json",
    },
    responseType: "json",
    params: {
      credit_memo_num,
      ref_invoice,
      return_address,
      to,
      from,
      customer_num,
      status,
      selected,
      page,
      order_by,
      sort_order,
      source: "csfa",
    },
  });

  return response;
}

async function sendCreditConfirmation({
  method,
  email,
  credit_memo_num,
  use_rga,
}) {
  const url = `${endpoints.MITCO_API_URL}/v1${endpoints.CREDIT_BASE + endpoints.CREDIT_PRINT}`;

  const response = await axios.get(url, {
    withCredentials: true,
    headers: {
      Accept: "application/json",
    },
    responseType: "blob",
    params: {
      method,
      email,
      credit_memo_num,
      use_rga,
    },
  });
  return response;
}

async function getProductById({ product_code }) {
  const response = await axios.get(
    endpoints.MITCO_API_URL +
      endpoints.CSFA_BASE +
      endpoints.CSFA_PRODUCTS +
      product_code +
      "/" +
      endpoints.CSFA_DETAIL_PRODUCT,
    {
      withCredentials: true,
      headers: {
        Accept: "application/json",
      },
    },
  );
  return response;
}

async function getAlternativeProduct({ product_code, qty }) {
  const response = await axios.get(
    endpoints.MITCO_API_URL +
      endpoints.CSFA_BASE +
      endpoints.CSFA_PRODUCTS +
      endpoints.CSFA_ALTERNATIVE_PRODUCT,
    {
      withCredentials: true,
      headers: {
        Accept: "application/json",
      },
      params: {
        product_code,
        qty,
      },
    },
  );
  return response;
}

// Order Endpoints

async function getOrderHistory() {
  const response = await axios.get(
    endpoints.MITCO_API_URL +
      endpoints.CSFA_BASE +
      endpoints.CSFA_ORDERS +
      endpoints.CSFA_ORDERS_HISTORY,
    {
      withCredentials: true,
      headers: {
        Accept: "application/json",
      },
    },
  );
  return response;
}

async function getOrderById({ order_num }) {
  const response = await axios.get(
    endpoints.MITCO_API_URL +
      endpoints.CSFA_BASE +
      endpoints.CSFA_ORDERS +
      order_num +
      "/" +
      endpoints.CSFA_ORDER,
    {
      withCredentials: true,
      headers: {
        Accept: "application/json",
      },
    },
  );
  return response;
}

async function getOrderItemRepresentation() {
  const response = await axios.get(
    endpoints.MITCO_API_URL +
      endpoints.CSFA_BASE +
      endpoints.CSFA_CART +
      endpoints.CSFA_CART_ITEM_AS_ORDER_ITEM,
    {
      withCredentials: true,
      headers: {
        Accept: "application/json",
      },
    },
  );
  return response;
}

async function getTrackFee() {
  const response = await axios.get(
    endpoints.MITCO_API_URL +
      endpoints.CSFA_BASE +
      endpoints.CSFA_CART +
      endpoints.CSFA_GET_TRACK_FEE,
    {
      withCredentials: true,
      headers: {
        Accept: "application/json",
      },
    },
  );
  return response;
}

// Customer Endpoints

async function getCustomerWarehouseCutoff({ warehouses }) {
  const response = await axios.get(
    endpoints.MITCO_API_URL +
      endpoints.CSFA_BASE +
      endpoints.CSFA_CUSTOMER +
      endpoints.CSFA_CUSTOMER_CUTOFF,
    {
      withCredentials: true,
      headers: {
        Accept: "application/json",
      },
      params: {
        warehouses,
      },
    },
  );
  return response;
}

async function getCustomerDetailsForOrder() {
  const response = await axios.get(
    endpoints.MITCO_API_URL +
      endpoints.CSFA_BASE +
      endpoints.CSFA_CUSTOMER +
      endpoints.CSFA_CUSTOMER_DETAILS_FOR_ORDER,
    {
      withCredentials: true,
      headers: {
        Accept: "application/json",
      },
    },
  );
  return response;
}

async function getCustomerLoginAs() {
  const response = await axios.get(
    endpoints.MITCO_API_URL +
      endpoints.CSFA_BASE +
      endpoints.CSFA_CUSTOMER +
      endpoints.CSFA_CUSTOMER_LOGIN_AS,
    {
      withCredentials: true,
      headers: {
        Accept: "application/json",
      },
    },
  );
  return response;
}

async function getProductListRowDetails({ product_code }) {
  const response = await axios.get(
    endpoints.MITCO_API_URL +
      endpoints.CSFA_BASE +
      endpoints.CSFA_PRODUCTS +
      product_code +
      "/" +
      endpoints.CSFA_PRODUCT_ROW_DETAIL,
    {
      withCredentials: true,
      headers: {
        Accept: "application/json",
      },
    },
  );
  return response;
}

async function getTrackMakesAndModels({ product_code }) {
  const response = await axios.get(
    endpoints.MITCO_API_URL +
      endpoints.CSFA_BASE +
      endpoints.CSFA_PRODUCTS +
      product_code +
      "/" +
      endpoints.CSFA_TRACK_MAKE_MODEL_MATCHES,
    {
      withCredentials: true,
      headers: {
        Accept: "application/json",
      },
    },
  );
  return response;
}

async function getProductFilterTypes() {
  const response = await axios.get(
    endpoints.MITCO_API_URL +
      endpoints.CSFA_BASE +
      endpoints.CSFA_PRODUCTS +
      endpoints.CSAF_PRODUCT_TYPE_FILTERS,
    {
      withCredentials: true,
      headers: {
        Accept: "application/json",
      },
    },
  );
  return response;
}

async function getProductHistory({ search, sort_by, page }) {
  const url = `${endpoints.MITCO_API_URL}${endpoints.CSFA_BASE}${endpoints.CSFA_PRODUCTS}${endpoints.CSFA_PRODUCT_HISTORY}`;

  const response = await axios.get(url, {
    withCredentials: true,
    headers: {
      Accept: "application/json",
    },
    params: {
      search: search || undefined,
      sort_by: sort_by || undefined,
      page: page || undefined,
      source: "csfa",
    },
  });
  return response;
}
// Cart Endpoints

async function getCart() {
  const response = await axios.get(
    endpoints.MITCO_API_URL + endpoints.CSFA_BASE + endpoints.CSFA_CART + "1/",
    {
      withCredentials: true,
      headers: {
        Accept: "application/json",
      },
    },
  );
  return response;
}

// admin endpoints
async function getAdminVars() {
  const response = await axios.get(
    endpoints.MITCO_API_URL +
      endpoints.CSFA_BASE +
      endpoints.CSFA_SITE_ADMIN +
      endpoints.CSFA_INITIAL_ADMIN_VARS,
    {
      withCredentials: true,
      headers: {
        Accept: "application/json",
      },
    },
  );
  return response;
}

// API Request Logs endpoints
async function getApiRequestLogs(params = {}) {
  const queryParams = new URLSearchParams();

  // Add all parameters to the query string
  Object.keys(params).forEach((key) => {
    if (
      params[key] !== undefined &&
      params[key] !== null &&
      params[key] !== ""
    ) {
      queryParams.append(key, params[key]);
    }
  });

  const queryString = queryParams.toString();
  const url = `${endpoints.MITCO_API_URL}${endpoints.LOGS_BASE}${endpoints.CSFA_API_LOGS}${queryString ? `?${queryString}` : ""}`;

  const response = await axios.get(url, {
    withCredentials: true,
    headers: {
      Accept: "application/json",
    },
  });
  return response;
}

async function getApiRequestLogDetail(logId) {
  const url = `${endpoints.MITCO_API_URL}${endpoints.LOGS_BASE}${endpoints.CSFA_API_LOGS}${logId}/`;
  console.log("[apiGet] getApiRequestLogDetail URL:", url, "logId:", logId);
  const response = await axios.get(url, {
    withCredentials: true,
    headers: {
      Accept: "application/json",
    },
  });
  return response;
}

async function getActiveVendorCategories() {
  const response = await axios.get(
    `${endpoints.MITCO_API_URL}${endpoints.CSFA_BASE}${endpoints.CSFA_SITE_ADMIN}get_active_vendor_categories/`,
    {
      withCredentials: true,
      headers: {
        Accept: "application/json",
      },
    },
  );
  return response;
}

async function getUserById(userId) {
  const response = await axios.get(
    `${endpoints.MITCO_API_URL}${endpoints.CSFA_BASE}${endpoints.CSFA_SITE_ADMIN}${userId}/get_user/`,
    {
      withCredentials: true,
      headers: {
        Accept: "application/json",
      },
    },
  );
  return response;
}

async function getTemplateUsers(userId) {
  const response = await axios.get(
    `${endpoints.MITCO_API_URL}${endpoints.CSFA_BASE}${endpoints.CSFA_SITE_ADMIN}${endpoints.CSFA_TEMPLATE_USERS}`,
    {
      withCredentials: true,
      headers: {
        Accept: "application/json",
      },
    },
  );
  return response;
}

async function getVersionByName(name) {
  const response = await axios.get(
    `${endpoints.MITCO_API_URL}${endpoints.VERSIONS_BASE}${endpoints.VERSION_BY_NAME}`,
    {
      withCredentials: true,
      headers: {
        Accept: "application/json",
      },
      params: { name },
    },
  );
  return response;
}

async function checkNewVersionAvailable({ name, currentVersion }) {
  const response = await axios.get(
    `${endpoints.MITCO_API_URL}${endpoints.VERSIONS_BASE}${endpoints.VERSION_CHECK_NEW}`,
    {
      withCredentials: true,
      headers: {
        Accept: "application/json",
      },
      params: {
        name,
        current_version: currentVersion,
      },
    },
  );
  return response;
}

async function getZipLookup(zip) {
  const response = await axios.get(
    `${endpoints.MITCO_API_URL}/v1${endpoints.CSFA_ZIP_LOOKUP}`,
    {
      withCredentials: true,
      headers: { Accept: "application/json" },
      params: { zip },
    },
  );
  return response;
}

async function checkDuplicatePo({
  customer_num,
  customer_po,
  company = "mitco",
}) {
  const response = await axios.get(`${endpoints.MITCO_API_URL}/v1/suborder/`, {
    withCredentials: true,
    headers: { Accept: "application/json" },
    params: {
      customer_num,
      customer_po,
      strict_match: true,
      order_by: "suborder_num",
      sort_order: "dsc",
      company,
    },
  });
  return response;
}

async function getAsyncJob(jobId, signal) {
  return axios.get(
    `${endpoints.MITCO_API_URL}${endpoints.CSFA_BASE}${endpoints.CSFA_ORDERS}${endpoints.CSFA_SHIPPING_JOB_STATUS}${jobId}/`,
    {
      withCredentials: true,
      headers: { Accept: "application/json" },
      timeout: 5000,
      signal,
    },
  );
}
